import Moveable from './Moveable'
import { CLASS_NAMES, DIRS } from '../../utils/constants'

export default class Character extends Moveable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: true,
      isPickable: false,
      isCrushable: true,
      level
    })
    this.pushingDirection = null
  }

  animRun() {}
  
  canMove(x, y) {
    const neighbour = this.level.getObjectAt(x, y)
    const emptyPlace = this.level.objectIsEmpty(neighbour)
    const canBrakeNeighbour = neighbour?.isBreakable && this.power >= neighbour.strength && !neighbour.isClass(CLASS_NAMES.CHARACTER)
    const canWalkThrough = neighbour.isClass && neighbour.isClass(CLASS_NAMES.CHARACTER) && neighbour.name !== 'dwarf'
    
    this.isBrakingGround = canBrakeNeighbour && neighbour.isClass(CLASS_NAMES.GROUND)

    return emptyPlace || canWalkThrough || canBrakeNeighbour || neighbour.isPickable ? neighbour : false
  }

  canMoveDir(DIR) {
    switch(DIR) {
      case DIRS.UP: return this.canMoveUp()
      case DIRS.DOWN: return this.canMoveDown()
      case DIRS.LEFT: return this.canMoveLeft()
      case DIRS.RIGHT: return this.canMoveRight()
      default: return false
    }
  }

  canMoveUp() {
    return this.canMove(this.position.x, this.position.y - 1)
  }
  canMoveDown() {
    return this.canMove(this.position.x, this.position.y + 1)
  }
  animPushRight() {
  }
  animPushLeft() {
  }
  canMoveLeft() {
    return this.canMove(this.position.x - 1, this.position.y)
  }
  canPushLeft() {
    const neighbour = this.level.getObjectAt(this.position.x - 1, this.position.y)
    const nothingBesides = this.level.isPositionClear(this.position.x - 2, this.position.y)
    const isAboutToFall = this.level.isPositionClear(this.position.x - 1, this.position.y + 1)
    const canPush = neighbour?.isMoveable && nothingBesides && !isAboutToFall
    return canPush
  }
  pushLeft() {
    const neighbour = this.level.getObjectAt(this.position.x - 1, this.position.y)
    const canMove = this.canMoveLeft()
    const canPush = this.canPushLeft()
    let pushed = false
    if(!canMove && canPush) {
      if(this.pushingDirection === DIRS.LEFT) {
        this.animPushLeft()
        pushed = true
        this.level.moveObject(neighbour, { x: this.position.x - 2, y: this.position.y })
        this.level.jumpIntoParallelGravity(neighbour)
        // clears pushing dir to let a new loop to push again
        this.pushingDirection = null
      } else {
        this.pushingDirection = DIRS.LEFT
        this.animPushLeft()
      }
    }
    return pushed
  }

  canMoveRight() {
    return this.canMove(this.position.x + 1, this.position.y)
  }
  
  canPushRight() {
    const neighbour = this.level.getObjectAt(this.position.x + 1, this.position.y)
    const nothingBesides = this.level.isPositionClear(this.position.x + 2, this.position.y)
    const isAboutToFall = this.level.isPositionClear(this.position.x + 1, this.position.y + 1)
    const canPush = neighbour?.isMoveable && nothingBesides && !isAboutToFall
    return canPush
  }
  
  pushRight() {
    const neighbour = this.level.getObjectAt(this.position.x + 1, this.position.y)
    const canMove = this.canMoveRight()
    const canPush = this.canPushRight()
    let pushed = false
    if(!canMove && canPush) {
      if(this.pushingDirection === DIRS.RIGHT) {
        this.animPushRight()
        this.level.moveObject(neighbour, { x: this.position.x + 2, y: this.position.y })
        this.level.jumpIntoParallelGravity(neighbour)
        // clears pushing dir to let a new loop to push again
        this.pushingDirection = null
        pushed = true
      } else {
        this.pushingDirection = DIRS.RIGHT
        this.animPushRight()
      }
    }
    return pushed
  }

  testProximity(targetPos, proximity = 1, onlyRightAngles) {
    const topLimit = this.position.y - proximity
    const bottomLimit = this.position.y + proximity
    const leftLimit = this.position.x - proximity
    const rightLimit = this.position.x + proximity
    let retVal = false
    const isInArea = targetPos.x >= leftLimit && targetPos.x <= rightLimit && targetPos.y >= topLimit && targetPos.y <= bottomLimit
    const isInRightAngle = targetPos.x === this.position.x || targetPos.y === this.position.y
    if(isInArea && (!onlyRightAngles || (onlyRightAngles && isInRightAngle))) {
      retVal = true
    }

    return retVal
  }
}

Character.className = CLASS_NAMES.CHARACTER
